/**
 * Compara kind de template de e-mail (Welcome/Csat/Nps), tolerante a caixa e valor numérico.
 * Não use para SurveyType — use matchesSurveyType (enums numéricos diferentes).
 */
export function matchesTemplateKind(
  actual: string | number | null | undefined,
  expected: string,
): boolean {
  const left = normalizeEmailTemplateKindToken(actual);
  const right = normalizeEmailTemplateKindToken(expected);
  if (!left || !right) {
    return false;
  }

  return left === right;
}

function normalizeEmailTemplateKindToken(value: string | number | null | undefined): string {
  if (value == null) {
    return '';
  }

  const raw = String(value).trim().toLowerCase();
  // EmailTemplateKind: Welcome = 1, Csat = 5, Nps = 6
  if (raw === '6' || raw === 'nps') {
    return 'nps';
  }

  if (raw === '5' || raw === 'csat') {
    return 'csat';
  }

  if (raw === '1' || raw === 'welcome') {
    return 'welcome';
  }

  return raw;
}
